import { date } from '../../../lib/helpers';
import { headers, search } from './attributes';

export default {
  data: () => ({
    search,
    dateMenu: false,
    dateFormatted: '',
    limit: '5',
    page: '1',
    options: {},
    headers,
    selectedRow: '',
  }),

  computed: {
    errorValidation() {
      return this.$store.state.rbac.mappingMID.errors;
    },
    loading() {
      return this.$store.state.rbac.mappingMID.loading;
    },
    merchants() {
      return this.$store.state.rbac.mappingMID.allMerchants;
    },
    totalMerchants() {
      return this.$store.state.rbac.mappingMID.totalMerchants;
    },
    totalPage() {
      return this.$store.state.rbac.mappingMID.totalPage;
    },

  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    dialogDelete(val) {
      if (!val) this.closeDelete();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.created_at);
        this.getData();
      },
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.username = '';
      this.search.role = '';
      this.search.created_at = '';
      this.getData();
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    mappingMID(data, view) {
      if (view !=='add') {
        this.$store.commit('rbac/mappingMID/setDetailData', data);
        this.$router.push({ path: `/mapping-mid/${view}/${data.id}` });
      } else {
        this.$router.push({ path: `/mapping-mid/${view}` });
      }
    },

    getData() {
      this.$store.commit('rbac/mappingMID/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('rbac/mappingMID/fetchListMapping', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },
  },
};